'use client';
import { useAuth } from '@/features/authentication/hooks/auth';
import Preloader from '@/features/preloader/components/Preloader';
import { usePathname, useRouter } from 'next/navigation';
import { useEffect } from 'react';

export default function DashboardLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const router = useRouter();
  const pathName = usePathname();

  const { user, isLoading } = useAuth();

  // Pages that guests are allowed to access
  const guestAccessible = ['/cart'];

  useEffect(() => {
    // Redirect only if user is not logged in AND page is not guest-accessible
    if (!isLoading && !user && !guestAccessible.includes(pathName)) {
      router.push(`/login?redirect=${pathName}`);
    }
  }, [isLoading, user, pathName, router]);

  if (isLoading || (!user && !guestAccessible.includes(pathName))) {
    return <Preloader />;
  }

  // if (!user) {
  //   router.push(`/login?redirect=${pathName}`);
  // }

  return (
    <div className="dashboard-container">
      <main>{children}</main>
    </div>
  );
}
